import {
    Checkbox,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import FormSection from '../../../components/atom/FormSection';
import { formatMoney } from '../../../utils';
import moment from 'moment';

function agentsPlusIdToText(agents, id) {
    const agent = agents?.find(a => a.id === id);
    if (agent) {
        return `${agent.name} (${agent.companyName || 'no company'})`;
    }
    return `Agent #${id}`;
}

function BookingItemTransactionHistory({
    values,
    transactionSum,
    setFieldValue,
    agents,
    canRefund = true,
    canModify = true
}) {
    const transactions = values?.transactions || [];

    // there should be a "delete_discount" list, that might include ids
    const deleteDiscounts = values?.delete_discounts || [];

    return (
        <FormSection title="Transactions, payments, discounts">
            <Grid
                xs={12}
                item
                container
                spacing={4}
                justifyContent="space-between"
                style={{ display: 'none' }}
            >
                <Grid item>
                    <Typography variant="h5" style={{ fontSize: '1rem' }}>
                        Booking item: {formatMoney(values?.amount)}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="h5" style={{ fontSize: '1rem' }}>
                        Cart value: {formatMoney(values?.cart_value)}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="h5" style={{ fontSize: '1rem' }}>
                        Transaction balance: {formatMoney(transactionSum)}
                    </Typography>
                </Grid>
            </Grid>
            <Typography variant="subtitle1" style={{ paddingTop: '2rem' }}>
                Transactions
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Type</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Payment Method</TableCell>
                        <TableCell>Card details</TableCell>
                        <TableCell>Note</TableCell>
                        <TableCell>Agent</TableCell>
                        <TableCell>Transaction time</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {transactions.map(transaction => (
                        <TableRow key={transaction.id}>
                            <TableCell>{transaction.type}</TableCell>
                            <TableCell>{formatMoney(transaction.amount)}</TableCell>
                            <TableCell>{transaction.payment_method}</TableCell>
                            <TableCell>
                                {transaction.last4 ? `**** **** **** ${transaction.last4}` : '-'}
                            </TableCell>
                            <TableCell>{transaction.note || '-'}</TableCell>
                            <TableCell>
                                {agentsPlusIdToText(agents, transaction.agent_id)}
                            </TableCell>
                            <TableCell>
                                {moment(transaction.created_at).format('MM/DD/YYYY h:mm A')}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Typography variant="subtitle1" style={{ paddingTop: '2rem' }}>
                Discounts
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Revoke</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Note</TableCell>
                        <TableCell>Agency discount</TableCell>
                        <TableCell>Vendor discount</TableCell>
                        <TableCell>Discount Package</TableCell>
                        <TableCell>Timeshare Booking</TableCell>
                        <TableCell>Agent</TableCell>
                        <TableCell>Created at</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {values?.discounts.map(discount => (
                        <TableRow key={discount.id}>
                            <TableCell>
                                <Checkbox
                                    size="small"
                                    disabled={!canRefund || !canModify}
                                    checked={deleteDiscounts.includes(discount.id)}
                                    onChange={e => {
                                        let newDelete = [...deleteDiscounts];
                                        if (e.target.checked === true) {
                                            // add to delete
                                            if (!newDelete.includes(discount.id)) {
                                                newDelete.push(discount.id);
                                            }
                                        } else {
                                            // remove from delete
                                            newDelete = newDelete.filter(id => id !== discount.id);
                                        }
                                        setFieldValue('delete_discounts', newDelete);
                                    }}
                                />
                            </TableCell>
                            <TableCell>{formatMoney(discount.amount)}</TableCell>
                            <TableCell>{discount.note || '-'}</TableCell>
                            <TableCell>
                                {discount.agency_discount
                                    ? formatMoney(discount.agency_discount)
                                    : '-'}
                            </TableCell>
                            <TableCell>
                                {discount.vendor_discount
                                    ? formatMoney(discount.vendor_discount)
                                    : '-'}
                            </TableCell>
                            <TableCell>
                                {discount.discount_package_name || (discount.discount_package_id ? `#${discount.discount_package_id}` : '-')}
                            </TableCell>
                            <TableCell>
                                {discount.timeshare_booking_item_id ? (
                                    <Link to={`/client/bookings/${discount.timeshare_booking_item_id}`}>
                                        View
                                    </Link>
                                ) : '-'}
                            </TableCell>
                            <TableCell>{agentsPlusIdToText(agents, discount.agent_id)}</TableCell>
                            <TableCell>
                                {moment(discount.created_at).format(
                                    'ddd, MMMM Do, YYYY [at] h:mm A'
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </FormSection>
    );
}
export default BookingItemTransactionHistory;
